export default {
  title: 'Declarații lunare',
  list: {
    empty_list: {
      title: 'Nicio declarație lunară încă.',
    },
    fields: {
      month: 'Lună',
      stripe_service_invoice_url: 'Factură Stripe',
      paypal_service_invoice_url: 'Factură PayPal',
    },
    button: {
      title: 'Export',
    },
  },
  export_modal: {
    title: 'Export',
    start_date: {
      title: 'Data de început',
      placeholder: 'dată',
    },
    end_date: {
      title: 'Data de sfârșit',
      placeholder: 'dată',
    },
    button: {
      export: 'Export',
      close: 'Închideți',
    },
  },
  toasts: {
    failed_to_load_data: 'Încărcarea datelor a eșuat',
  },
};
